<template>
	<div>
		<transition name="fade"><router-view /></transition>
	</div>
</template>

<script>
    export default {
        name: 'home',
        created() {
            // 判断用户是否登录
            this.isLogin();
        },
        methods: {
            isLogin() {
                this.$Spin.show();
                this.axios.post('/adminLogin/isLogin').then(res => {
                    console.log(res);
                    this.$Spin.hide();
                    if(res.status == 201){
						this.$Message.error(res.msg);
                    }
                })
            }
        }
    }
</script>

<style lang="less">
    .hs-screen-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .hs-screen-row {
        display: inline-block;
        margin-right: 10px;
        padding: 5px 0;
    }
    .hs-btn-row{
        display: inline-block;
        padding: 0 2px;
    }
    .hs-page{
        text-align: right;
        margin-top: 20px;
       margin-right: -10px;
    }
    .hs-describe{
        color: #aaaaaa;
        font-size: 13px;
        height: 20px;
        line-height: 25px;
    }
	.j-img-echo{
		height: 130px;
		display: flex;
		margin-bottom: 10px;
		align-items: center;
		justify-content: center;
		background-color: #f8f8f9;
		overflow: hidden;
	}
	.j-img-echo img{
		width: auto;
		height: 100%;
	}
</style>
